<div class="outer">
  <div class="inner">
    <slot />
  </div>
</div>

<style lang="scss" src="./card-preview-mobile.scss"></style>
